// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__rCmob","left":"Virtual_left__PKQcn","wrapper":"Virtual_wrapper__WhcgP"};